import DemoBannerButtons from "../../components/demo-pages-components/demo-banner/DemoBannerButtons.tsx";
import BannerWithElement from "../../components/demo-pages-components/demo-banner/BannerWithElement.tsx";
import DemoDescription from "../../components/demo-pages-components/DemoDescription.tsx";
import PurchaseExample from "../../components/demo-pages-components/purchase-example/PurchaseExample.tsx";
import Solutions from "../../components/accelerating-online-page-components/solutions/Solutions.tsx";
import DemonstrationsCards from "../../components/demonstrations/DemonstrationsCards.tsx";
import GetStartedBanner from "../../components/home-page-components/get-started-banner/GetStartedBanner.tsx";
import {DemoPisSolutionsListConfig} from "../../configs/demo-pages/demoPisSolutionsListConfig.ts";
import {PisDemonstrationsCardsConfig} from "../../configs/demo-pages/pisDemoCards.ts";
import {useState} from "react";
import CustomHelmet from "../../components/helmet/CustomHelmet.tsx";
import {LegalTextsState} from "../../context/LegalTextsContext.tsx";
import LegalModal from "../../components/demo-pages-components/legal-texts/LegalModal.tsx";

const DemoPisPage = () => {

    const [channelsInCheckout, setChannelsInCheckout] = useState(true);
    const {isPaymentTermsOpen, isPrivacyPolicyOpen} = LegalTextsState();

    return (
        <>
            <CustomHelmet title={'titles.demo_pis_payments'} />
            <div className="opy-content">
                <div className="opy-page-demo-payment">
                    <BannerWithElement heading={'pis_demo'}
                                       element={<DemoBannerButtons
                                           channelsInCheckout={channelsInCheckout}
                                           setChannelsInCheckout={setChannelsInCheckout} />}
                                       slider={false} />
                    <DemoDescription />
                    <PurchaseExample page={'pis'} channelsInCheckout={channelsInCheckout} />
                    <Solutions solutions={DemoPisSolutionsListConfig} />
                    <DemonstrationsCards config={PisDemonstrationsCardsConfig} />
                    <GetStartedBanner bannerText={'boost_your_business'}
                                      linkText={'get_started'}
                                      linkClassname={'opy-button opy-button--white opy-button--medium text-center'}
                                      linkTo={'routes.start_using_accept_payments'} />
                </div>
            </div>
            {isPaymentTermsOpen && <LegalModal heading={'payment_terms'} type={'payment_terms'}/>}
            {isPrivacyPolicyOpen && <LegalModal heading={'privacy_policy'} type={'privacy_terms'}/>}
        </>
    )
}

export default DemoPisPage;
